import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { GridContainer, GridItem } from '@xing-com/grid';
import {
  space3XL,
  spaceL,
  spaceXXL,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const StyledContainer = styled(GridContainer)`
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  width: 100vw;
  max-width: 100vw;
  margin-bottom: ${space3XL};
  background-color: ${xdlColorBackgroundTertiary};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spaceL};
  padding: ${spaceXXL} 0;
`;

export const RegisterButton: React.FC = () => {
  return (
    <StyledContainer>
      <GridItem span={12}>
        <Headline size="xlarge" sizeConfined="xxlarge" noMargin>
          <FormattedMessage id="UPSELL_LOGGED_OUT_PAGE_PRODUCTS_REGISTER_HEADLINE" />
        </Headline>
      </GridItem>
      <GridItem span={12}>
        <Button
          variant="secondary"
          to={`/start/signup?sc_o=upsellfunnel_products_welcome_signup_cta2_click`}
        >
          <FormattedMessage id="UPSELL_LOGGED_OUT_PAGE_PRODUCTS_REGISTER_CTA" />
        </Button>
      </GridItem>
    </StyledContainer>
  );
};
